interface PageStat {
  page: string;
  count: number;
}

interface TopPagesProps {
  data: PageStat[];
  total: number;
}

export default function TopPages({ data, total }: TopPagesProps) {
  return (
    <div className="bg-white dark:bg-stone-900 rounded-xl border border-stone-100 dark:border-stone-800 p-5">
      <h3 className="text-sm font-semibold text-stone-700 dark:text-stone-300 mb-4 flex items-center gap-2">
        <i className="ri-file-list-3-line text-rose-500" /> Top Pages
      </h3>
      {data.length === 0 ? (
        <p className="text-stone-400 text-sm text-center py-6">No data yet</p>
      ) : (
        <ul className="space-y-3">
          {data.map((item) => {
            const pct = total > 0 ? Math.round((item.count / total) * 100) : 0;
            return (
              <li key={item.page}>
                <div className="flex items-center justify-between mb-1">
                  <span className="text-xs text-stone-600 dark:text-stone-400 truncate max-w-[200px]" title={item.page}>
                    {item.page || '/'}
                  </span>
                  <span className="text-xs font-mono font-semibold text-stone-700 dark:text-stone-300 ml-2 whitespace-nowrap">
                    {item.count.toLocaleString()} <span className="text-stone-400 font-normal">({pct}%)</span>
                  </span>
                </div>
                <div className="h-1.5 bg-stone-100 dark:bg-stone-800 rounded-full overflow-hidden">
                  <div
                    className="h-full bg-rose-400 rounded-full transition-all duration-500"
                    style={{ width: `${pct}%` }}
                  />
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
